import { dictionary } from "@/schemas/dictionary";
import { z } from "@/zod";

const shiftReportDepartment = dictionary.extend({
  description: z.string().max(250).optional(),
});

export const readShiftReportDepartment = shiftReportDepartment.readonly();
export const writeShiftReportDepartment = shiftReportDepartment.omit({
  id: true,
});
